export const iconFontAwesomeAccessibilityPersonWalkingWithCane = (
	<i className="fa-solid fa-person-walking-with-cane"></i>
);
